<template>
	<div :class="[isLargeScreen?'Register':'RegisterMobile']">
   <div class="nav" v-if="isLargeScreen">
     <div class="nav-inner-pannel">
      <div class="logo">
        <img :src="commenUrl+platInfo.logo" v-if="platInfo.logo">
      </div>
      
      <div class="back-home"><router-link to="/">首页</router-link></div>
     </div>
   </div>
   <div class="nav" v-else>
     <div class="logo-img"></div>
     <div class="logo-text">账号注册</div>
   </div>
   <div class="main">
    <div class="register-wrap">
      <div class="register-hand" v-if="isLargeScreen">
        <div>账号注册</div>
        <div class="go-login">已有账号，<router-link to="login">立即登录></router-link></div>
      </div>
      <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
        <el-form-item prop="loginName" key="loginName">
          <el-input placeholder="请输入用户名" v-model="registerForm.loginName" @change="loginNameVerify">
          </el-input>
        </el-form-item>
        <el-form-item  prop="registTel">
          <el-input placeholder="请输入手机号码或邮箱" v-model="registerForm.registTel">
          </el-input>
        </el-form-item>
        <el-form-item  prop="mobileCode">
          <div class="val-code-wrap">
            <el-input placeholder="请输入短信验证码" v-model="registerForm.mobileCode">
            </el-input>
            <div class="code-btn">
              <a href="javascript:;" @click="mobileVerify(registerForm.registTel)" v-if="!countdownDisable">获取验证码</a>
              <a href="javascript:;" v-else>{{countdownText}}</a>
            </div>
            
          </div>
        </el-form-item>
        <el-form-item prop="password" class="password-wrap">
            <el-input :type="psdShowFlag?'text':'password'" placeholder="请输入6-20位数字及字母组合密码" v-model="registerForm.password"
            @input="handlePasswordChange"></el-input>
            <!-- <el-input type="password" placeholder="请输入6-20位数字及字母组合密码" v-model="registerForm.password" v-else
            @input="handlePasswordChange"></el-input> -->
            <div class="psd-isShow" @click="psdShowFlag=!psdShowFlag">
              <span class="iconfont" v-if="psdShowFlag">&#xe623;</span>
              <span class="iconfont" v-else>&#xe624;</span>
            </div>
            
        </el-form-item>
        <el-form-item prop="confirmPassword" class="password-wrap">
            <el-input :type="confirmpsdShowFlag?'text':'password'" placeholder="请再次输入登录密码" v-model="registerForm.confirmPassword">
            </el-input>
            <!-- <el-input type="password" placeholder="请再次输入登录密码" v-model="registerForm.confirmPassword" v-else>
            </el-input> -->
            <div class="psd-isShow" @click="confirmpsdShowFlag=!confirmpsdShowFlag">
              <span class="iconfont" v-if="confirmpsdShowFlag">&#xe623;</span>
              <span class="iconfont" v-else>&#xe624;</span>
            </div>
        </el-form-item>
        <div class="register-agree">
          <span>商通中心账号服务需要联网，并获取您的账号、所在区域、浏览器设置信息，以及您主动上传的个人基本资料和身份信息。点击“注册”，即表示您同意上述内容及</span>
          <router-link to="/registerAgree" custom v-slot="{href}"><a :href="href" target="_blank">《商通中心用户注册协议》</a></router-link>
        </div>
        <el-button type="primary" class="login-sub-btn" @click="onSubmit(registerFormRef)" :loading='registerflag'><span>注册</span></el-button>
        <div class="go-login" v-if="!isLargeScreen">已有账号，<router-link to="login">立即登录></router-link></div>
      </el-form>
      
    </div>
   </div>
   <div class="footer" v-if="isLargeScreen">
     <div class="footer-inner-pannel">
       <!-- <div><span>鲁ICP备2024099623号</span><span>公安备案</span><span>增值电信业务经营许可证</span><span>营业执照</span><span>食品经营许可证</span></div>
       <div><span>潍坊农业开发发展集团有限公司(版权所有)</span><span>齐民商通科技服务有限公司(运营公司)</span><span>北京新盟风控科技有限公司(技术公司)</span><span>客服电话：0536-7267526</span></div>
       <div class="float-r"><span>法律声明</span><span>隐私政策声明</span></div> -->
       <Footer :platInfo="platInfo"></Footer>
     </div>
   </div>
   <el-dialog v-model="dialogVisible" title="图形验证码" :width="isLargeScreen?500:'96%'" center destroy-on-close>
      <div class="form-panel">
        <el-form label-width="0">
          <el-form-item prop="checkCode">
              <div class="image-code-wrap">
                <div><el-input placeholder="请输入图形验证码" v-model="checkCode"></el-input></div>
                <el-image :src="imgCodeurl" @click="createImgCode"></el-image>
              </div>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer" style="justify-content:center;">
          <el-button type="primary" @click="getCode">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { getCurrentInstance, reactive, ref,computed,onMounted,onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Md5 from 'js-md5';
import Footer from '../components/footerZz.vue'
const { proxy } = getCurrentInstance();
const props = defineProps({
    platInfo: {
        type: Object,
        default: {}
    }
});

// 1. 定义一个响应式变量来存储窗口宽度
const windowWidth = ref(window.innerWidth);

// 2. 定义一个方法来更新窗口宽度
const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

// 3. 使用 computed 属性来判断屏幕大小
//    这里以 768px 为分界线，你可以根据需求修改
const isLargeScreen = computed(() => {
  return windowWidth.value >= 768;
});
// 4. 组件挂载时：添加 resize 事件监听器
onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

// 5. 组件卸载时：移除 resize 事件监听器，防止内存泄漏
onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});
const router=useRouter();
let registerForm=reactive({});
const registerFormRef=ref(null);
const registerflag=ref(false);
// 自定义校验规则 - 确认密码
const validateConfirmPassword = (rule, value, callback) => {
  // 先判断确认密码是否为空
  if (!value) {
    return callback(new Error('请再次输入登录密码'));
  }
  // 判断两次密码是否一致
  if (value !== registerForm.password) {
    callback(new Error('密码不一致，请重新输入'));
  } else {
    callback(); // 校验通过
  }
};
let registerRules=reactive({
  loginName: [
    { required: true, message:"请输入用户名", trigger: "blur" },
    {
      pattern: /^[0-9A-Za-z_]{4,16}$/,
      message: "请输入4-16位数字/字母/下划线组成的用户名",
      trigger: "blur",
    },
    {
      validator: (rule, value, callback) => {
        if (registerForm.loginNameFlag) {
          callback(new Error("用户名已存在"))
        } else {
          callback()
        }
      }
    }
  ],
  registTel: [
    { required: true, message:"请输入手机号或邮箱", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        const telReg=/^[1][0-9]{10}$/;
        const mailReg=/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})$/
        if(!telReg.test(value)&&!mailReg.test(value)){
          callback(new Error("请输入正确的手机号码或邮箱"))
        }else{
          callback()
        }
        if (registerForm.registTelFlag) {
          callback(new Error("手机号已存在"))
        } else {
          callback()
        }
      }
    }
  ],
  mobileCode: [
    { required: true, message:"请输入验证码", trigger: "blur" },
  ],
  password: [
    { required: true, message:"请输入密码", trigger: "blur" },
    {
      pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)[a-zA-Z0-9]{6,20}$/,
      message: "请输入6-20位数字及字母组合密码",
      trigger: "blur",
    },
  ],
  confirmPassword: [{required: true,message: '请再次输入登录密码',trigger: "blur"},
        {validator: validateConfirmPassword, trigger: 'blur'}
      ],
});

// 密码变化时触发确认密码校验（判空+防抖）
const handlePasswordChange = () => {
  if (registerFormRef.value && registerForm.confirmPassword) {
    // 手动校验确认密码字段，捕获提示避免控制台报错
    registerFormRef.value.validateField('confirmPassword', (err) => {
      if (err) console.debug('确认密码校验提示：', err);
    });
  }
};
function getQueryParam(param) {//获取地址拦指定参数值
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
function onSubmit(formEl){
  formEl.validate((valid) => {
    if (valid) {
      console.log('submit!')
    } else {
      return false
    }

    registerflag.value=true;
    var password = Md5(registerForm.password);
    var passwordC = Md5(registerForm.confirmPassword);
    proxy.$request({
      url:"SYSTEM_MEMB_REGISTER",
      method: "post",
      data:{
        "confirmPassword":passwordC,
        "loginName": registerForm.loginName,
        "mobileCode": registerForm.mobileCode,
        "password": password,
        "registTel":registerForm.registTel
      },
    }).then((res) => {
      if(res.data.code=='000'){
        if(getQueryParam("redirect_url")){
          router.push({path:'/login',query:{'redirect_url':getQueryParam("redirect_url")}});
        }else{
          router.push('/login');
        }
        
      }
      registerflag.value=false;
    }).catch((err) => {
      console.log(err);
      registerflag.value=false;
    });
  });
}

let imgCodeurl=ref("");
let dialogVisible=ref(false);
function createImgCode(){
  proxy.$request({
    url:"SYSTEM_MOBILE_CHECKCODE_CREATE",
    method: "post",
    data:{"mobile":registerForm.registTel},
  }).then((res) => {
    if(res.data.code=='000'){
      imgCodeurl.value=res.data.result.data;
      dialogVisible.value=true;
    }
  }).catch((err) => {
    console.log(err);
  });
}
let codeType=ref("0");
function mobileVerify() {//手机号码验证
  registerForm.registTelFlag=false;
  registerFormRef.value.validateField("registTel",(valid) => {
    if(!valid)return false
    proxy.$request({
      url:"SYSTEM_MEMB_CHECKMOBOREMAILEXIST",
      method: "post",
      data: {
        "key": registerForm.registTel,
        "mainFlag": true
      },
    }).then((res) => {
      if(res.data.code=='000'){
        registerForm.registTelFlag=false;
        if(res.data.result){
          codeType.value=res.data.result.type;
        }
        createImgCode();
      }else{
        registerForm.registTelFlag=true;
      }
      registerFormRef.value.validateField("registTel",(valid)=>{
        console.log(valid)
      })
    }).catch((err)=>{
      console.log(err);
    })
  });
}

const checkCode=ref("");
function getCode() {//获取验证码
  if(!checkCode.value){
    proxy.$message.warning("请输入图形验证码");
    return
  }
  let url="SYSTEM_MOBILE_VALCODE_CREATE";
  let sendData={
    "mobile": registerForm.registTel,
    "checkCode":checkCode.value,
  }
  if(codeType.value=='1'){//邮箱1 电话0
    url="SYSTEM_EMAIL_SENDEMAILVALCODE";
    sendData={
      "email": registerForm.registTel,
      "checkCode":checkCode.value,
    }
  }
  proxy.$request({
    url:url,
    method: "post",
    data:sendData
  }).then((res) => {
    if(res.data.code=='000'){
      getCountDown();
    }
    dialogVisible.value=false;
  }).catch((err) => {
    console.log(err)
  });
}
let timer=null,count=0;
let countdownDisable=ref(false);
let countdownText=ref("");
function getCountDown() {
  const TIME_COUNT = 60;
  if (!timer) {
    count = TIME_COUNT;
    timer = setInterval(() => {
      if (count > 0 && count <= TIME_COUNT) {
        countdownDisable.value = true;
        let str = count--;
        let str0=""+str;
        if(str<10){
          str0="0"+str
        }
        countdownText.value = str0 + "s后重新获取";
      } else {
        clearInterval(timer);
        timer = null;
        countdownDisable.value = false;
        countdownText.value=""
      }
    }, 1000);
  }
}
const psdShowFlag=ref(false);
const confirmpsdShowFlag=ref(false);
</script>

<style lang="less" scoped>
.Register{
  @font-face {
  font-family: 'iconfont';  /* Project id 5014541 */
  src: url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.woff2?t=1757040619729') format('woff2'),
       url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.woff?t=1757040619729') format('woff'),
       url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.ttf?t=1757040619729') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';  /* Project id 5014541 */
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  .nav{
    width: 100%;
    // height: 3.91vw;
    background: #fff;
    .nav-inner-pannel{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.99vw 1.56vw;
    }
    .logo{
      // width: 10.89vw;
      // width: 15.47vw;
      height: 1.93vw;
      img{
        height: 100%;
      }
    }
    a{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.93vw;
      color: #222222;
      line-height: 1vw;
    }
  }
  .main{
    flex:1;
    min-height: 27vw;
    width: 100%;
    // background: url(../assets/images/login_bg.gif) no-repeat center;
    // background-size: 100% 100%;
    background-color: #F3F4F9 ;
    display: flex;
    justify-content: center;
    align-items: center;
    .register-wrap{
      width: 46.875vw;
      // height: 36.458vw;
      height: 90%;
      max-height: 36.458vw;
      background: #fff;
      .register-hand{
        padding: 1vw;
        border-bottom: 1px solid #ECECEC;
        display: flex;
        justify-content: space-between;
        margin-bottom: 2.86vw;
        div{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.9375vw;
          color: #222222;
          line-height: 1.3vw;
        }
        .go-login{
          font-size: 0.73vw;
          a{
            color: #1663FF;
          }
        }
      }
      .el-form{
        width: 22.4vw;
        margin: 0 auto;
        .el-form-item{
          margin-bottom: 1vw;
          .el-form-item__content{
            line-height: 2.396vw;
            .el-input{
              .el-input__wrapper{
                border-radius: 4px;
                .el-input__inner{
                  height: 2.396vw;
                  line-height: 2.396vw;
                }
              }
            }
          }
        }
        .password-wrap{
          position: relative;
          .psd-isShow{
            position: absolute;
            right:0.833vw;
            cursor: pointer;
            user-select: none;
          }
        }
        .val-code-wrap{
          position: relative;
          width: 100%;
         // margin-bottom: 1.33vw;
          .el-input__inner{
            padding-right: 21.87vw;
          }
          .code-btn{
            position: absolute;
            right: 0.52vw;
            top: 1px;
            cursor: pointer;
            a{
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #3D7EFD;
            }
          }
        }
        .register-agree{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.625vw;
          color: #222222;
          line-height: 1vw;
          margin-bottom: 1vw;
          a{
            color: #1663FF;
          }
        }
        .login-sub-btn{
          width: 100%;
          height: 2.396vw;
          background: #3D7EFD;
        }
      }
    }
  }
  .footer{
    width: 100%;
   // height: 4.583vw;
    background: #E3E8F2;
    .footer-inner-pannel{
      padding: 1vw 1.56vw;
      position: relative;
    }
    // div{
    //   margin-bottom: 0.42vw;
    // }
    // div.float-r{
    //   position: absolute;
    //   right: 0;
    //   top: 1vw;
    // }
    // span{
    //   font-family: PingFangSC, PingFang SC;
    //   font-weight: 400;
    //   font-size: 0.73vw;
    //   color: #2E2F2F;
    //   line-height: 1vw;
    //   margin-right: 0.833vw;
    // }
  }
  :deep(.el-dialog){
    height: 225px !important;

    .el-dialog__footer{
        .dialog-footer{
            .el-button{
              width: 6.25vw;
              height: 1.875vw;
              font-size: 0.625vw;
              border-radius: 0;
              background-color: #3d70fd;
            }
        }
    }
    .el-dialog__body{
      height: auto;
      .form-panel{
        display: flex;
        justify-content: center;
        .el-input{
          width: 14.58vw;
          height: 1.875vw;
          line-height: 1.875vw;
          .el-input__wrapper{
            border-radius:0;
          }
          
        }
        .image-code-wrap{
          display: flex;
          align-items: center;
          width: 100%;
          padding-top: 1vw;
          .el-image{
            width: 5.99vw;
            height: 1.875vw;
          }
        }
        .image-code-wrap>div{
          flex: 1;
        }
      }
      .el-image{
        width: 100%;
        height: auto;
        img{
          width: 100%;
        }
      }
    }
    
  }
}
.RegisterMobile{
  @font-face {
  font-family: 'iconfont';  /* Project id 5014541 */
  src: url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.woff2?t=1757040619729') format('woff2'),
       url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.woff?t=1757040619729') format('woff'),
       url('//at.alicdn.com/t/c/font_5014541_gnobwtuxqy4.ttf?t=1757040619729') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';  /* Project id 5014541 */
  }
  .nav{
    text-align: center;
    padding-top: 7.47vw;
    margin-bottom: 5.33vw;
    .logo-img{
      width: 12.27vw;
      height: 12.27vw;
      margin-bottom: 2.67vw;
    }
    .logo-text{
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 4.533vw;
      color: #171717;
      line-height: 6.4vw;
    }
  }
  .main{
    padding: 0 5.33vw;
    
    :deep(.register-wrap){
      .el-form{
        .el-form-item{
          margin-bottom: 4vw;
          .el-form-item__content{
            line-height: 12.27vw;
            .el-input{
              .el-input__wrapper{
                border-radius: 4px;
                .el-input__inner{
                  height: 12.27vw;
                  font-size:16px;
                  
                }
              }
            }
          }
        }
      }
    }
    .password-wrap{
      position: relative;
      .psd-isShow{
        position: absolute;
        right:3.2vw;
        cursor: pointer;
        user-select: none;
      }
    }
    .val-code-wrap{
      position: relative;
      width: 100%;
      margin-bottom: 1.33vw;
      .el-input__inner{
        padding-right: 21.87vw;
      }
      .code-btn{
        position: absolute;
        right: 3.2vw;
        top:3.7vw;
        line-height: 5.33vw;
        cursor: pointer;
        a{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 3.733vw;
          color: #3D7EFD;
        }
      }
    }
    .register-agree{
      margin-bottom: 5.33vw;
      span,a{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 3.2vw;
        color: #222222;
        line-height:5.33vw;
      }
      a{
        color: #3D7EFD;
      }
    }
    .login-sub-btn{
      width: 100%;
      height: 12.27vw;
      background: #3D7EFD;
      border-radius: 4px;
      margin-bottom: 7.47vw;
      span{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 4.27vw;
        color: #FFFFFF;
      }
    }
    .go-login{
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 3.733vw;
      color: #222222;
      a{
        color: #1663FF;
      }
    }
  }
  :deep(.el-dialog){
    .el-dialog__footer{
        .dialog-footer{
            .el-button{
              width: 100%;
              height: 12.27vw;
              font-size: 3.2vw;
              border-radius: 0;
              background-color: #3d70fd;
            }
        }
    }
    .el-dialog__body{
      height: auto;
      .form-panel{
        display: flex;
        justify-content: center;
        .el-input{
          flex: 1;
          height: 12.27vw;
          line-height: 12.27vw;
          .el-input__wrapper{
            border-radius:0;
            font-size:16px;
          }
          
        }
        .image-code-wrap{
          display: flex;
          align-items: center;
          width: 100%;
          .el-image{
            width: 40vw;
            height: 12.27vw;
          }
        }
        .image-code-wrap>div{
          flex: 1;
        }
      }
      .el-image{
        width: 100%;
        height: auto;
        img{
          width: 100%;
        }
      }
    }
    
  }
}
</style>